module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-panel', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.loading ? 'hide col-sm-12' : 'col-sm-12'
  }, [_c('form', {
    attrs: {
      "method": "post",
      "role": "form",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.activeTab !== 'vrbo-default-configuration-tab' ? _vm.update(_vm.users) : _vm.saveVrboDefaultConfigurationTabData()
      }
    }
  }, [_c('div', {
    staticClass: "panel settings-page"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.$t("account.settings.title")) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-actions"
  }, [_c('div', [(!_vm.user.is_team_member && _vm.user.plan_id !== 4) ? _c('button', {
    staticClass: "btn btn-default btn-warning waves-effect waves-classic",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getProperties()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("button.import")) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.activeTab !== 'credit_card') ? _c('button', {
    staticClass: "btn btn-warning waves-effect waves-classic",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("button.save")) + "\n                  ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "account-tabs"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    class: _vm.activeTab == 'informations' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('informations')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("account.settings.info_section.title")) + "\n                ")]), _vm._v(" "), (!_vm.user.is_team_member) ? _c('li', {
    class: _vm.activeTab == 'services' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('services')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("account.settings.user_services_section.tab_title")) + "\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.user.is_team_member) ? _c('li', {
    class: _vm.activeTab == 'platforms' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('platforms')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("account.settings.user_platforms_section.tab_title")) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('li', {
    class: _vm.activeTab == 'message_templates' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('message_templates')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("account.settings.message_templates_section.tab_title")) + "\n                ")]), _vm._v(" "), (!_vm.user.is_team_member) ? _c('li', {
    class: _vm.activeTab == 'credit_card' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('credit_card')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("account.settings.credit_card.title")) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('li', {
    class: _vm.activeTab == 'sms_info' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('sms_info')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("account.settings.sms_info.title")) + "\n                ")]), _vm._v(" "), (_vm.users.vrbo_enabled) ? _c('li', {
    class: _vm.activeTab === 'vrbo-default-configuration-tab' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('vrbo-default-configuration-tab')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("rentals.detail.platforms.vrbo.vrbo")) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('li', {
    class: _vm.activeTab === 'website' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('website')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("account.settings.website.title")) + "\n                ")]), _vm._v(" "), _c('li', {
    class: _vm.activeTab === 'event-logger' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('event-logger')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("logs.tab")) + "\n                ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'informations'),
      expression: "activeTab == 'informations'"
    }],
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: _vm.users.parent == null ? 'col-sm-4' : 'col-sm-6'
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("account.settings.info_section.title")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-6 form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-first-name"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.first_name")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.users.first_name),
      expression: "users.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "settings-first-name",
      "type": "text",
      "id": "settings-first-name",
      "required": ""
    },
    domProps: {
      "value": (_vm.users.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.users, "first_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6 form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-last-name"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.last_name")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.users.last_name),
      expression: "users.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "settings-last-name",
      "type": "text",
      "id": "settings-last-name",
      "required": ""
    },
    domProps: {
      "value": (_vm.users.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.users, "last_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-email"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.email")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.users.email),
      expression: "users.email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "settings-email",
      "type": "text",
      "id": "settings-email",
      "required": ""
    },
    domProps: {
      "value": (_vm.users.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.users, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-phone"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.phone")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.users.phone),
      expression: "users.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "settings-phone",
      "type": "text",
      "id": "settings-phone",
      "required": ""
    },
    domProps: {
      "value": (_vm.users.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.users, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "user-avatar-container"
    }
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("input.photo")))]), _vm._v(" "), _c('div', {
    staticClass: "avatar-wrapper text-align-center"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.users.avatar),
      expression: "users.avatar"
    }],
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteUserAvatar(_vm.users)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.users.avatar ? (_vm.users.avatarPath ? _vm.users.avatarPath : _vm.users.avatar) : 'static/material/global/portraits/avatar.png'
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "avatar-wrapper"
  }, [_c('input', {
    attrs: {
      "name": "input-file-now",
      "type": "file",
      "id": "input-file-now",
      "data-plugin": "dropify",
      "data-default-file": "",
      "data-allowed-file-extensions": "jpg png jpeg gif"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])])])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-setup mt-10 w-full",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openModal('#change-password-modal')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('account.users.change_password')) + "\n                      ")])])])]), _vm._v(" "), _c('div', {
    class: _vm.users.parent == null ? 'col-sm-4' : 'col-sm-6'
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("account.settings.billing_section.title")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-address"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.address")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.users.address),
      expression: "users.address"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "settings-address",
      "type": "text",
      "id": "settings-address",
      "required": ""
    },
    domProps: {
      "value": (_vm.users.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.users, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-zip"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.zip_code")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.users.zip_code),
      expression: "users.zip_code"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "settings-zip",
      "type": "text",
      "id": "settings-zip",
      "required": ""
    },
    domProps: {
      "value": (_vm.users.zip_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.users, "zip_code", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-city"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.city")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.users.city),
      expression: "users.city"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "settings-city",
      "type": "text",
      "id": "settings-city",
      "required": ""
    },
    domProps: {
      "value": (_vm.users.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.users, "city", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-country"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.country")))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.users.country_id),
      expression: "users.country_id"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "settings-country",
      "id": "settings-country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.users, "country_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.countries), function(country) {
    return _c('option', {
      domProps: {
        "value": country.id
      }
    }, [_vm._v("\n                          " + _vm._s(country.name) + "\n                        ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-currency"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.currency")))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.users.currency_id),
      expression: "users.currency_id"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "settings-currency",
      "id": "settings-currency"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.users, "currency_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.currencies), function(currency) {
    return _c('option', {
      domProps: {
        "value": currency.id
      }
    }, [_vm._v("\n                          " + _vm._s(currency.name) + " " + _vm._s(' (' + currency.symbol + ')') + "\n                        ")])
  }))])])]), _vm._v(" "), (_vm.users.parent == null) ? _c('div', {
    staticClass: "col-sm-4",
    attrs: {
      "id": "user-data"
    }
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("account.settings.user_data_section.title")) + "\n                    ")]), _vm._v(" "), (!_vm.user.is_team_member && _vm.user.plan_id !== 4) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-beds24ApiKey"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.user_key")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.users.beds24ApiKey),
      expression: "users.beds24ApiKey"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "settings-beds24ApiKey",
      "type": "text",
      "id": "settings-beds24ApiKey",
      "required": ""
    },
    domProps: {
      "value": (_vm.users.beds24ApiKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.users, "beds24ApiKey", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.user.is_team_member) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-api-key"
    }
  }, [_vm._v(_vm._s(_vm.$t('input.sh_api_key')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.users.api_key),
      expression: "users.api_key"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "settings-api-key",
      "required": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.users.api_key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.users, "api_key", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.user.is_team_member) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-website-key"
    }
  }, [_vm._v(_vm._s(_vm.$t('input.sh_website_key')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.users.web_key),
      expression: "users.web_key"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "settings-website-key",
      "required": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.users.web_key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.users, "web_key", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.user.is_team_member) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "booking-engine-link"
    }
  }, [_vm._v(_vm._s(_vm.$t('input.engine_link')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.users.engine_link),
      expression: "users.engine_link"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "booking-engine-link",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.users.engine_link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.users, "engine_link", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "change-settings-lang"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.lang")))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.users.lang),
      expression: "users.lang"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "settings-lang",
      "id": "change-settings-lang"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.users, "lang", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "en"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.$t("account.settings.message_templates_section.english")) + "\n                        ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fr"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.$t("account.settings.message_templates_section.french")) + "\n                        ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pt"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.$t("account.settings.message_templates_section.portugal")) + "\n                        ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "es"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.$t("account.settings.message_templates_section.spanish")) + "\n                        ")])])]), _vm._v(" "), (_vm.user.plan_id !== 4) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-association-code"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.association_code")))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "name": "settings-association-code",
      "type": "text",
      "id": "settings-association-code",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.users.association_code
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.user_team.is_team_member) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-parent-email"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.team_parent_email")))]), _vm._v(" "), _vm._l((_vm.user_team.parent_emails), function(email) {
    return _c('div', [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": "settings-parent-email",
        "disabled": "disabled"
      },
      domProps: {
        "value": email
      }
    })])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-default"
  }, _vm._l((_vm.stripe_accounts), function(stripe, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "settings-card",
      attrs: {
        "id": "settings-card"
      }
    }, [_c('div', {
      staticClass: "card card-transparent"
    }, [_c('div', {
      staticClass: "card-block"
    }, [_c('div', {}, [_c('div', {
      staticClass: "d-flex"
    }, [_c('span', {
      staticClass: "pull-left m-r-10"
    }, [_c('img', {
      attrs: {
        "src": "static/assets/images/stripe-logo.jpeg",
        "width": "45"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10 flex-1 full-width overflow-ellipsis"
    }, [_c('p', [_vm._v("\n                                      " + _vm._s(_vm.$t('account.settings.user_data_section.stripe_integration')) + " - " + _vm._s(stripe.exchange_id) + "\n                                    ")]), _vm._v(" "), _c('h6', {}, [_c('span', {
      staticClass: "semi-bold"
    }, [_vm._v(_vm._s(stripe.name))])])]), _vm._v(" "), _c('div', {
      staticClass: "auto channel-change col-md-2 pull-right"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('div', {
      staticClass: "dropdown"
    }, [_c('button', {
      staticClass: "btn btn-primary dropdown-toggle",
      attrs: {
        "type": "button",
        "data-toggle": "dropdown"
      }
    }, [_c('i', {
      staticClass: "bulle"
    })]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu dropdown-menu-right"
    }, [_c('button', {
      staticClass: "dropdown-item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openStripeAccountDeleteModal('#deleteStripeAccount', index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n                                          ")]), _vm._v(" "), _c('button', {
      staticClass: "dropdown-item",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#newStripeAccount"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openStripeEditModal(stripe)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    }), _vm._v(" " + _vm._s(_vm.$t('button.edit')) + "\n                                          ")])])])])])])])])])])])
  })), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-cons text-uppercase",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#addStripeAccount",
      "id": "connectStripeButton",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openStripeEditModal()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('button.connect_stripe_account')) + "\n                    ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'services' && !_vm.user.is_team_member),
      expression: "activeTab == 'services' && !user.is_team_member"
    }],
    staticClass: "panel-body",
    attrs: {
      "id": "user-service-configure-net-key"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    staticClass: "actions min-height d-flex justify-content-end"
  }, [(_vm.users.setting.netatmo_client_id) ? _c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "btn btn-primary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "bulle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('a', {
    staticClass: "dropdown-item waves-effect waves-light waves-round",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteNetatmoAccount()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.index.users.delete")))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row list-rental-empty-step pt-0"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-setup mt-10",
    attrs: {
      "tynav": "",
      "nav-pillspe": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openServiceModal('#configure-netatmo-modal')
      }
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.$t("account.settings.user_services_section.configure_netatmo")) + "\n                        ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    staticClass: "actions min-height d-flex justify-content-end"
  }, [(_vm.isTheKeysConnected) ? _c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "btn btn-primary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "bulle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('a', {
    staticClass: "dropdown-item waves-effect waves-light waves-round",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteTheKeys()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.index.users.delete")))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row list-rental-empty-step pt-0"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-setup mt-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openServiceModal('#configure-key-modal')
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("account.settings.user_services_section.configure_key")) + "\n                          ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    staticClass: "row list-rental-empty-step"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-setup mt-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openServiceModal('#configure-integromat-modal')
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("account.settings.user_services_section.configure_integromat")) + "\n                          ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-10"
  }, [_c('div', {
    staticClass: "col-sm-4",
    class: _vm.superCheckin.id ? 'super-checkin' : ''
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [(_vm.superCheckin.id) ? _c('div', {
    staticClass: "actions min-height d-flex justify-content-end"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "btn btn-primary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "bulle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('a', {
    staticClass: "dropdown-item waves-effect waves-light waves-round",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteSuperCheckinAccount(_vm.superCheckin.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.index.users.delete")))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row list-rental-empty-step"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-setup mt-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openServiceModal('#configure-super-checkin-modal', true)
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("account.settings.user_services_section.configure_super_checkin")) + "\n                          ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    staticClass: "actions min-height d-flex justify-content-end"
  }, [(_vm.isIgloohomeConnected) ? _c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "btn btn-primary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "bulle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('a', {
    staticClass: "dropdown-item waves-effect waves-light waves-round",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteIgloohome()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.index.users.delete")))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row list-rental-empty-step pt-0"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-setup mt-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openServiceModal('#configure-igloohome')
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("account.settings.user_services_section.igloohome.configure")) + "\n                          ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    staticClass: "actions min-height d-flex justify-content-end"
  }, [(_vm.isIgloohomeV2Connected) ? _c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "btn btn-primary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "bulle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('a', {
    staticClass: "dropdown-item waves-effect waves-light waves-round",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteIgloohomeV2()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.index.users.delete")))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row list-rental-empty-step pt-0"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-setup mt-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openServiceModal('#configure-igloohome-v2')
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("account.settings.user_services_section.igloohomev2.configure")) + "\n                          ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    staticClass: "actions min-height d-flex justify-content-end"
  }, [(_vm.isNukiConnected) ? _c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "btn btn-primary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "bulle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('a', {
    staticClass: "dropdown-item waves-effect waves-light waves-round",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteNukiLock()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.index.users.delete")))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row list-rental-empty-step pt-0"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-setup mt-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openServiceModal('#configure-nuki-lock')
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("account.settings.user_services_section.nuki_lock.configure")) + "\n                          ")])])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'platforms' && !_vm.user.is_team_member),
      expression: "activeTab == 'platforms'  && !user.is_team_member"
    }],
    staticClass: "panel-body",
    attrs: {
      "id": "user-platforms"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    staticClass: "row list-rental-empty-step"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-setup mt-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.user.airbnbapi_enabled ? _vm.showAddNewAccount() : _vm.showAddWizard()
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("account.settings.user_platforms_section.configure_airbnb")) + "\n                          ")])])])]), _vm._v(" "), (_vm.airbnbAccounts.length > 0) ? _c('table', {
    staticClass: "table table-responsive",
    staticStyle: {
      "table-layout": "fixed"
    },
    attrs: {
      "id": "airbnb-accounts-table"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v("État")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.airbnbAccounts), function(account) {
    return _c('tr', [_c('td', {
      staticClass: "text-align-center",
      staticStyle: {
        "word-wrap": "break-word",
        "overflow-wrap": "break-word"
      }
    }, [_vm._v("\n                            " + _vm._s(account.username) + "\n                          ")]), _vm._v(" "), _c('td', {
      staticClass: "text-align-center"
    }, [(account.status == 1) ? _c('p', {
      staticStyle: {
        "color": "rgb(52, 165, 52)",
        "font-size": "12px",
        "padding": "5px",
        "background-color": "#EBF9EB",
        "width": "80px",
        "border-radius": "20px"
      }
    }, [_vm._v("\n                              Connecté\n                            ")]) : _vm._e(), _vm._v(" "), (account.status == 2) ? _c('p', {
      staticStyle: {
        "color": "rgb(255,255,255)",
        "font-size": "12px",
        "padding": "5px",
        "background-color": "#c3c7c3",
        "width": "80px",
        "margin-left": "28px",
        "border-radius": "20px"
      }
    }, [_vm._v("\n                              En Attente\n                            ")]) : _vm._e(), _vm._v(" "), (account.status == 0) ? _c('div', {
      staticStyle: {
        "display": "flex",
        "flex-direction": "column",
        "padding": "5px",
        "background-color": "#FFEFEF",
        "margin-left": "28px",
        "border-radius": "20px",
        "width": "150px"
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#CD2B31",
        "font-weight": "bold",
        "font-size": "12px"
      }
    }, [_c('i', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": "static/assets/images/SuperHote_icons/close.svg",
        "alt": "",
        "width": "20px",
        "height": "20px"
      }
    })]), _vm._v("\n                                À reconnecter\n                              ")])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "channel-change"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('div', {
      staticClass: "dropdown"
    }, [_c('button', {
      staticClass: "btn btn-primary dropdown-toggle",
      attrs: {
        "type": "button",
        "data-toggle": "dropdown",
        "disabled": _vm.airbnbActiveLoading
      }
    }, [_c('i', {
      staticClass: "bulle"
    })]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu dropdown-menu-right"
    }, [(!_vm.user.airbnbapi_enabled) ? _c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openEditAirbnbAccountModal(account)
        }
      }
    }, [_vm._v("\n                                      " + _vm._s(_vm.$t("button.edit")) + "\n                                    ")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.user.airbnbapi_enabled ? _vm.openImportAirbnbXmlNewRentalsModal(account) : _vm.openImportNewRentalsModal(account)
        }
      }
    }, [_vm._v("\n                                      " + _vm._s(_vm.$t("button.import_rentals")))]), _vm._v(" "), _c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteAirbnbAccount(account.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("admin.index.users.delete")))]), _vm._v(" "), _c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.user.airbnbapi_enabled ? _vm.reconnectAirbnbAccountWithAirbnbXml(account.id) : _vm.reconnectAirbnbAccount(account.id)
        }
      }
    }, [_vm._v("\n                                      " + _vm._s(_vm.$t("admin.index.users.reconnect")) + "\n                                    ")])])])])])])])
  }))]) : _vm._e()])]), _vm._v(" "), (_vm.users.vrbo_enabled) ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    staticClass: "row list-rental-empty-step"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-setup mt-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openVrboUserConnectionModal()
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("rentals.detail.platforms.vrbo.connect_vrbo")) + "\n                          ")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    staticClass: "row list-rental-empty-step"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-setup mt-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openGoogleUserConnectionModal()
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("rentals.detail.platforms.google.connect_google")) + "\n                          ")])])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'event-logger'),
      expression: "activeTab === 'event-logger'"
    }]
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h3', {
    staticClass: "inner-title"
  }, [_vm._v(_vm._s(_vm.$t("logs.title")))]), _vm._v(" "), _c('div', {
    staticClass: "pb-2"
  }, _vm._l((Object.keys(_vm.logs)), function(logDate) {
    return _c('div', [_c('h3', {
      staticClass: "text-left mb-2 font-weight-bold",
      staticStyle: {
        "font-size": "14px",
        "color": "#57668b"
      }
    }, [_vm._v("\n                          " + _vm._s(logDate) + "\n                        ")]), _vm._v(" "), _vm._l((_vm.logs[logDate]), function(log) {
      return _c('div', {
        staticClass: "d-block"
      }, [_c('b', {
        attrs: {
          "title": log.event_at
        }
      }, [_vm._v(_vm._s(log.hour_at) + " - ")]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(log.value)
        }
      })])
    }), _vm._v(" "), (!_vm.logs[logDate].length) ? _c('div', {
      staticClass: "d-block"
    }, [_c('span', {
      staticClass: "font-italic",
      staticStyle: {
        "color": "#b7b7b7"
      }
    }, [_vm._v(_vm._s(_vm.$t("logs.nologs")))])]) : _vm._e(), _vm._v(" "), _c('hr', {
      staticStyle: {
        "width": "15px",
        "margin-left": "0",
        "color": "#c7cce5"
      }
    })], 2)
  }))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'message_templates'),
      expression: "activeTab == 'message_templates'"
    }],
    staticClass: "panel-body"
  }, [_c('v-templates')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'payment_rules'),
      expression: "activeTab == 'payment_rules'"
    }],
    staticClass: "panel-body"
  }, [_c('v-rules')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'credit_card'),
      expression: "activeTab == 'credit_card'"
    }],
    staticClass: "panel-body"
  }, [_c('v-card')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'sms_info'),
      expression: "activeTab == 'sms_info'"
    }],
    staticClass: "panel-body"
  }, [_c('v-sms-info')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'vrbo-default-configuration-tab'),
      expression: "activeTab === 'vrbo-default-configuration-tab'"
    }],
    staticClass: "panel-body"
  }, [_c('v-vrbo-default-configuration-tab', {
    ref: "vrboDefaultConfigurationTab",
    attrs: {
      "user": _vm.users,
      "userId": _vm.users.id
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'website'),
      expression: "activeTab === 'website'"
    }],
    staticClass: "panel-body"
  }, [_c('website', {
    attrs: {
      "pixelHead": _vm.users.website_settings ? _vm.users.website_settings.google_pixel_head : '',
      "pixelBody": _vm.users.website_settings ? _vm.users.website_settings.google_pixel_body : '',
      "thankYou": _vm.users.website_settings ? _vm.users.website_settings.google_pixel_thank_you : '',
      "customStyle": _vm.users.website_settings ? _vm.users.website_settings.custom_style : ''
    },
    on: {
      "updateWebsiteSettings": _vm.updateWebsiteSettings
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "configure-netatmo-modal",
      "aria-hidden": "false",
      "aria-labelledby": "exampleGrid",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("account.settings.user_services_section.netatmo_title")) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#configure-netatmo-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row m-t-15"
  }, [_c('div', {
    staticClass: "form-group col-sm-6 form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-netatmo-client-id"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.netatmo_client_id")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.users.setting.netatmo_client_id),
      expression: "users.setting.netatmo_client_id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "settings-netatmo-client-id",
      "required": ""
    },
    domProps: {
      "value": (_vm.users.setting.netatmo_client_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.users.setting, "netatmo_client_id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6 form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-netatmo-client-secret"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.netatmo_client_secret")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.users.setting.netatmo_client_secret),
      expression: "users.setting.netatmo_client_secret"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "settings-netatmo-client-secret",
      "required": ""
    },
    domProps: {
      "value": (_vm.users.setting.netatmo_client_secret)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.users.setting, "netatmo_client_secret", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6 form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-netatmo-access-token"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.netatmo_access_token")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.users.setting.netatmo_access_token),
      expression: "users.setting.netatmo_access_token"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "settings-netatmo-access-token",
      "required": ""
    },
    domProps: {
      "value": (_vm.users.setting.netatmo_access_token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.users.setting, "netatmo_access_token", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6 form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-netatmo-refresh-token"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.netatmo_refresh_token")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.users.setting.netatmo_refresh_token),
      expression: "users.setting.netatmo_refresh_token"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "settings-netatmo-refresh-token",
      "required": ""
    },
    domProps: {
      "value": (_vm.users.setting.netatmo_refresh_token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.users.setting, "netatmo_refresh_token", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#configure-netatmo-modal')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("button.cancel")) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit",
      "disabled": _vm.btnDisabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sync_devices(_vm.users.setting)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("button.sync_and_save_devices")) + "\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "configure-key-modal",
      "aria-hidden": "false",
      "aria-labelledby": "exampleGrid",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("account.settings.user_services_section.key_title")) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#configure-key-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "setup-successful"
  }, [_c('div', {
    staticClass: "quick-tour"
  }, [_c('iframe', {
    attrs: {
      "src": "https://player.vimeo.com/video/320365069?title=0&byline=0&portrait=0",
      "width": "520",
      "height": "300",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-15"
  }, [_c('div', {
    staticClass: "form-group col-6 form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-key-username"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.username")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theKeys.username),
      expression: "theKeys.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "settings-key-username",
      "required": ""
    },
    domProps: {
      "value": (_vm.theKeys.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.theKeys, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6 form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-key-password"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.password")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theKeys.password),
      expression: "theKeys.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "settings-key-password",
      "required": ""
    },
    domProps: {
      "value": (_vm.theKeys.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.theKeys, "password", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#configure-key-modal')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("button.cancel")) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit",
      "disabled": _vm.btnSyncLocksDisabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sync_locks()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("button.sync_and_save_the_keys")) + "\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "configure-integromat-modal",
      "aria-hidden": "false",
      "aria-labelledby": "exampleGrid",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("account.settings.user_services_section.integromat_title")) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#configure-integromat-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "setup-successful"
  }, [_c('div', {
    staticClass: "quick-tour"
  }, [_c('iframe', {
    attrs: {
      "src": "https://player.vimeo.com/video/320140775",
      "width": "520",
      "height": "300",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-15"
  }, [_c('div', {
    staticClass: "form-group col-12 form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-integromat-api-key"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.api_key")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.users.integromat_api_key),
      expression: "users.integromat_api_key"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "",
      "id": "settings-integromat-api-key",
      "required": ""
    },
    domProps: {
      "value": (_vm.users.integromat_api_key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.users, "integromat_api_key", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#configure-integromat-modal')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("button.ok")) + "\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "configure-super-checkin-modal",
      "aria-hidden": "false",
      "aria-labelledby": "exampleGrid",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("account.settings.user_services_section.super_checkin_title")) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#configure-super-checkin-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "setup-successful"
  }, [_c('div', {
    staticClass: "quick-tour"
  })])])]), _vm._v(" "), _c('v-loading', {
    attrs: {
      "isLoading": _vm.superCheckin.loading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), (!_vm.superCheckin.loading) ? _c('div', {
    staticClass: "row mt-15"
  }, [_c('div', {
    staticClass: "form-group col-6 form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-super-checkin-username"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.username")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.superCheckin.superCheckinUsername),
      expression: "superCheckin.superCheckinUsername"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "settings-super-checkin-username",
      "required": ""
    },
    domProps: {
      "value": (_vm.superCheckin.superCheckinUsername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.superCheckin, "superCheckinUsername", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6 form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-super-checkin-password"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.password")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.superCheckin.superCheckinPassword),
      expression: "superCheckin.superCheckinPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "settings-super-checkin-password",
      "required": ""
    },
    domProps: {
      "value": (_vm.superCheckin.superCheckinPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.superCheckin, "superCheckinPassword", $event.target.value)
      }
    }
  })])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#configure-super-checkin-modal')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("button.cancel")) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.syncSuperCheckin()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("button.sync_and_save_locks")) + "\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade bs-example-modal-lg add-new-airbnb-account",
    attrs: {
      "id": "wizard-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body modal-padding"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 form-content"
  }, [(_vm.airbnbActiveStep == 1) ? _c('div', [_c('v-loading', {
    attrs: {
      "isLoading": _vm.abAccount.loading
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.abAccount.loading),
      expression: "!abAccount.loading"
    }]
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.airbnbConnectUpdate()
      }
    }
  }, [_c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title-icon"
  }, [_c('i', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/SuperHote_icons/wrench.svg",
      "alt": ""
    }
  })]), _vm._v("\n                                " + _vm._s(_vm.$t('account.settings.user_platforms_section.fill_account_credentials')) + "\n                              ")])]), _vm._v(" "), (_vm.abAccount.error) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissable"
  }, [(_vm.abAccount.id & _vm.abAccount.user_id) ? _c('div', [_vm._v("\n                                " + _vm._s(_vm.$t("account.settings.verification1")) + "\n                                "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.abAccount.id ? 'https://www.airbnb.com/airlock?al_id=' + _vm.abAccount.id : ''
    }
  }, [_vm._v("\n                                  " + _vm._s(_vm.abAccount.id ?
    _vm.$t("account.settings.clickhere") : ''))]), _vm._v("\n                                " + _vm._s(_vm.$t("account.settings.verification2")) + "\n                              ")]) : _c('div', [_vm._v(_vm._s(_vm.abAccount.error))])]) : _vm._e(), _vm._v(" "), (_vm.abAccount.success) ? _c('div', {
    staticClass: "alert alert-success alert-dismissable",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.abAccount.success) + "\n                            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "airbnb_username"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.airbnb_username")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.abAccount.airbnbUsername),
      expression: "abAccount.airbnbUsername"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "airbnb_username",
      "required": "",
      "disabled": _vm.airbnbActiveLoading
    },
    domProps: {
      "value": (_vm.abAccount.airbnbUsername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.abAccount, "airbnbUsername", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "airbnb_password"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.airbnb_password")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.abAccount.airbnbPassword),
      expression: "abAccount.airbnbPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "airbnb_password",
      "required": "",
      "disabled": _vm.airbnbActiveLoading
    },
    domProps: {
      "value": (_vm.abAccount.airbnbPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.abAccount, "airbnbPassword", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.abAccount.errorMsg && _vm.abAccount.errorMsg.length > 0),
      expression: "abAccount.errorMsg && abAccount.errorMsg.length > 0"
    }],
    staticStyle: {
      "color": "#D7092E",
      "font-size": "13px",
      "font-style": "italic"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.abAccount.errorMsg)
    }
  }), _vm._v(" "), _c('v-loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveLoading),
      expression: "airbnbActiveLoading"
    }],
    attrs: {
      "isLoading": true,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-right",
    attrs: {
      "type": "submit",
      "disabled": _vm.airbnbActiveLoading
    }
  }, [_vm._v(_vm._s(_vm.$t("button.next")))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.airbnbActiveStep == 2) ? _c('div', [_c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "panel default"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-title verification-title"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("account.settings.user_platforms_section.airlock_validation_title")) + "\n                              ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 auto",
      "text-align": "center"
    }
  }, [_c('v-loading', {
    attrs: {
      "isLoading": true,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "padding-top": "24px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('account.settings.user_platforms_section.airlock_validation'))
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "rgb(245, 225, 229)",
      "padding": "10px",
      "border-radius": "5px",
      "margin": "10px 0px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('account.settings.user_platforms_section.airlock_validation_sub'))
    }
  })])], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.airbnbActiveStep == 3) ? _c('div', [_c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title-icon"
  }, [_c('i', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/SuperHote_icons/cogs.svg",
      "alt": ""
    }
  })]), _vm._v("\n                            " + _vm._s(_vm.$t('account.settings.user_platforms_section.verify_and_connect')) + "\n                          ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel default"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-title verification-title"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('account.settings.user_platforms_section.verification_method_choice')) + "\n                              ")]), _vm._v(" "), _vm._l((_vm.abAccount.mfaOptions), function(option) {
    return _c('div', {
      staticClass: "m-10 radio-custom radio-primary"
    }, [_vm._l((option.data.phone_numbers), function(pn) {
      return (option.data.phone_numbers) ? _c('div', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.verificationFrictionType),
          expression: "verificationFrictionType"
        }],
        attrs: {
          "type": "radio",
          "id": option.name,
          "name": "airbnb_verification_method"
        },
        domProps: {
          "value": option.name + '-' + pn.id,
          "checked": _vm._q(_vm.verificationFrictionType, option.name + '-' + pn.id)
        },
        on: {
          "change": function($event) {
            _vm.verificationFrictionType = option.name + '-' + pn.id
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "control-label",
        attrs: {
          "for": option.name
        },
        domProps: {
          "innerHTML": _vm._s('Confirm your phone number <b>' + pn.obfuscated + '</b> via ' + (option.name === 'phone_verification_via_text' ? 'text message' : 'a phone call'))
        }
      })]) : _vm._e()
    }), _vm._v(" "), (option.name === 'email_code_verification') ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.verificationFrictionType),
        expression: "verificationFrictionType"
      }],
      attrs: {
        "type": "radio",
        "id": option.name,
        "name": "airbnb_verification_method"
      },
      domProps: {
        "value": option.name + '-' + option.data.delivery_methods[0].id,
        "checked": _vm._q(_vm.verificationFrictionType, option.name + '-' + option.data.delivery_methods[0].id)
      },
      on: {
        "change": function($event) {
          _vm.verificationFrictionType = option.name + '-' + option.data.delivery_methods[0].id
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "control-label",
      attrs: {
        "for": option.name
      },
      domProps: {
        "innerHTML": _vm._s('Confirm your e-mail <b>' + option.data.obfuscated_email_address + '</b>')
      }
    })]) : _vm._e()], 2)
  })], 2)])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.airbnbConnectUpdate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.next")))])]) : _vm._e(), _vm._v(" "), (_vm.airbnbActiveStep == 4) ? _c('div', [_c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel default"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-title verification-title"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('account.settings.user_platforms_section.confirm_airbnb_sent_code')) + "\n                              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material col-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "airbnb_code"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.airbnb_code")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.airbnbVerificationCode),
      expression: "airbnbVerificationCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "airbnb_code",
      "required": ""
    },
    domProps: {
      "value": (_vm.airbnbVerificationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.airbnbVerificationCode = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.airbnbConnectUpdate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.next")))])]) : _vm._e(), _vm._v(" "), (_vm.airbnbActiveStep == 5) ? _c('div', [_c('v-loading', {
    attrs: {
      "isLoading": _vm.abAccount.loading
    }
  }), _vm._v(" "), (!_vm.abAccount.loading) ? _c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "icon md-check"
  }), _vm._v(" " + _vm._s(_vm.$t("onboarding.import_rentals")) + "\n                          ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "setup-successful onboarding-educational"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.newAirbnbRentals.length > 0) ? _c('div', [_c('p', {
    staticClass: "import-rentals-header"
  }, [_vm._v("\n                                      " + _vm._s(_vm.$t("onboarding.select_rentals_to_import")) + "\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material m-t-15"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), (!_vm.smallLoading) ? _c('ul', {
    staticClass: "sub-items checkbox-primary mt-20 airbnb-rentals"
  }, [_c('li', {
    staticClass: "checkbox-custom checkbox-primary text-align-left m-b-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.abAccount.allRentalsSelected),
      expression: "abAccount.allRentalsSelected"
    }],
    attrs: {
      "type": "checkbox",
      "id": "all-rentals"
    },
    domProps: {
      "checked": Array.isArray(_vm.abAccount.allRentalsSelected) ? _vm._i(_vm.abAccount.allRentalsSelected, null) > -1 : (_vm.abAccount.allRentalsSelected)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.abAccount.allRentalsSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.abAccount, "allRentalsSelected", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.abAccount, "allRentalsSelected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.abAccount, "allRentalsSelected", $$c)
        }
      }, function($event) {
        _vm.selectAllRentals('all')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "all-rentals"
    }
  }, [_vm._v(_vm._s(_vm.$t("onboarding.select_all")))])]), _vm._v(" "), _vm._l((_vm.newAirbnbRentals), function(rental) {
    return _c('li', {
      staticClass: "checkbox-custom checkbox-primary text-align-left ml-15"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rental.checked),
        expression: "rental.checked"
      }],
      attrs: {
        "type": "checkbox",
        "id": ("airbnb-rental-" + (rental.id))
      },
      domProps: {
        "checked": Array.isArray(rental.checked) ? _vm._i(rental.checked, null) > -1 : (rental.checked)
      },
      on: {
        "change": [function($event) {
          var $$a = rental.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(rental, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(rental, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(rental, "checked", $$c)
          }
        }, _vm.selectAllRentals]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("airbnb-rental-" + (rental.id))
      }
    }, [_vm._v(_vm._s(rental.name))])])
  })], 2) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('v-loading', {
    attrs: {
      "isLoading": _vm.newAirbnbRentals.length === 0 && _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), (_vm.newAirbnbRentals.length === 0 && !_vm.smallLoading) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('onboarding.no_rentals')))])]) : _vm._e()], 1)])])])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-right",
    attrs: {
      "type": "button",
      "disabled": _vm.abAccount.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importAirbnbListings($event)
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.next")) + "\n                      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-right mr-10",
    attrs: {
      "type": "submit",
      "disabled": _vm.abAccount.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.skipImport($event)
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.skip_for_now")) + "\n                      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.activeStep == 6) ? _c('div', [(!_vm.abAccount.loading) ? _c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "icon md-check"
  }), _vm._v(" " + _vm._s(_vm.$t("onboarding.airbnb_reconnecting")) + "\n                          ")])]), _vm._v(" "), _c('div', {
    staticClass: "start-now-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-center waves-effect waves-classic btn-save text-uppercase",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("onboarding.airbnb_start_now")) + "\n                          ")])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 wizart-content"
  }, [_c('div', {
    staticClass: "wizart-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "close-popup-layout"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dismiss()
      }
    }
  }, [_c('i', {
    staticClass: "icon md-close"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "wizart-list"
  }, [_c('li', {
    staticClass: "wizart-point",
    class: _vm.airbnbActiveStep == 1 ? 'active' : ''
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveStep == 1),
      expression: "airbnbActiveStep == 1"
    }]
  }, [_vm._v(" 1 ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveStep > 1),
      expression: "airbnbActiveStep > 1"
    }]
  }, [_c('i', {
    staticClass: "icon md-check"
  })]), _vm._v("\n                        " + _vm._s(_vm.$t('account.settings.user_platforms_section.fill_account_credentials')) + "\n                      ")]), _vm._v(" "), _c('li', {
    staticClass: "wizart-point",
    class: _vm.airbnbActiveStep == 2 ? 'active' : ''
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveStep <= 2),
      expression: "airbnbActiveStep <= 2"
    }]
  }, [_vm._v(" 2 ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveStep > 2),
      expression: "airbnbActiveStep > 2"
    }]
  }, [_c('i', {
    staticClass: "icon md-check"
  })]), _vm._v("\n                        " + _vm._s(_vm.$t('account.settings.user_platforms_section.confirm_captcha')) + "\n                      ")]), _vm._v(" "), _c('li', {
    staticClass: "wizart-point",
    class: _vm.airbnbActiveStep == (3 || 4) ? 'active' : ''
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveStep <= 4),
      expression: "airbnbActiveStep <= 4"
    }]
  }, [_vm._v(" 3 ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveStep > 4),
      expression: "airbnbActiveStep > 4"
    }]
  }, [_c('i', {
    staticClass: "icon md-check"
  })]), _vm._v("\n                        " + _vm._s(_vm.$t('account.settings.user_platforms_section.verify_and_connect')) + "\n                      ")]), _vm._v(" "), (!_vm.isReconnectingAccount) ? _c('li', {
    staticClass: "wizart-point",
    class: _vm.airbnbActiveStep == 5 ? 'active' : ''
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveStep <= 5),
      expression: "airbnbActiveStep <= 5"
    }]
  }, [_vm._v(" 4 ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveStep > 5),
      expression: "airbnbActiveStep > 5"
    }]
  }, [_c('i', {
    staticClass: "icon md-check"
  })]), _vm._v("\n                        " + _vm._s(_vm.$t("onboarding.import_process")) + "\n                      ")]) : _vm._e()])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade bs-example-modal-lg add-new-airbnb-account_template",
    attrs: {
      "id": "wizard-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body modal-padding"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 form-content"
  }, [(_vm.airbnbActiveStep == 1) ? _c('div', [_c('v-loading', {
    attrs: {
      "isLoading": _vm.abAccount.loading
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.abAccount.loading),
      expression: "!abAccount.loading"
    }]
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.airbnbConnectAibnb()
      }
    }
  }, [_c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title-icon"
  }, [_c('i', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/SuperHote_icons/wrench.svg",
      "alt": ""
    }
  })]), _vm._v("\n                                " + _vm._s(_vm.abAccount.id === null ?
    _vm.$t('account.settings.user_platforms_section.add_new_account_airbnb') :
    _vm.$t('account.settings.user_platforms_section.reconnect_airbnb')) + "\n                              ")])]), _vm._v(" "), (_vm.abAccount.id == null) ? _c('div', {
    staticClass: "alert-message"
  }, [_c('div', {
    staticClass: "alert-title"
  }, [_c('i', [_c('img', {
    attrs: {
      "src": "static/assets/images/SuperHote_icons/alert.svg",
      "alt": "",
      "width": "28",
      "height": "28"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "attention"
  }, [_vm._v(_vm._s(_vm.$t('account.settings.user_platforms_section.attention')))])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row"
  }, [_c('p', {
    staticClass: "alert-text"
  }, [_vm._v("\n                                  " + _vm._s(_vm.$t('account.settings.user_platforms_section.step1_content1')) + "\n                                ")]), _vm._v(" "), _c('p', {
    staticClass: "alert-text"
  }, [_vm._v("\n                                  " + _vm._s(_vm.$t('account.settings.user_platforms_section.step1_content2')) + "\n                                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step1-content"
  }, [_c('p', {
    staticClass: "text-step"
  }, [_vm._v(_vm._s(_vm.abAccount.id === null ?
    _vm.$t('account.settings.user_platforms_section.step1_content3') :
    _vm.$t('account.settings.user_platforms_section.step1_content4')))]), _vm._v(" "), (_vm.abAccount.id != null) ? _c('p', {
    staticClass: "account-name"
  }, [_vm._v(" " + _vm._s(_vm.abAccount.airbnbUsername))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step1-option"
  }, [_c('div', {
    staticClass: "alert-title"
  }, [_c('label', {
    staticClass: "text-step",
    attrs: {
      "for": "checkbox1"
    }
  }, [_vm._v("\n                                    Mon compte\n                                  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOption),
      expression: "selectedOption"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "value": "owner_account",
      "id": "checkbox1"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedOption, "owner_account")
    },
    on: {
      "change": function($event) {
        _vm.selectedOption = "owner_account"
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "alert-title"
  }, [_c('label', {
    staticClass: "text-step",
    attrs: {
      "for": "checkbox2"
    }
  }, [_vm._v("\n                                    Le compte de quelqu'un d'autre\n                                  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOption),
      expression: "selectedOption"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "value": "another_account",
      "id": "checkbox2"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedOption, "another_account")
    },
    on: {
      "change": function($event) {
        _vm.selectedOption = "another_account"
      }
    }
  })])])]), _vm._v(" "), (_vm.selectedOption === 'another_account') ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "add_another_account",
    attrs: {
      "for": "airbnb_username"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.airbnb_another_username")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_another_account_airbnb),
      expression: "email_another_account_airbnb"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "airbnb_username",
      "required": "",
      "disabled": _vm.airbnbActiveLoading
    },
    domProps: {
      "value": (_vm.email_another_account_airbnb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email_another_account_airbnb = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.abAccount.success) ? _c('div', {
    staticClass: "alert alert-success alert-dismissable",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.abAccount.success) + "\n                            ")]) : _vm._e(), _vm._v(" "), _c('v-loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveLoading),
      expression: "airbnbActiveLoading"
    }],
    attrs: {
      "isLoading": true,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-right",
    attrs: {
      "type": "submit",
      "disabled": _vm.airbnbActiveLoading
    }
  }, [_vm._v(_vm._s(_vm.$t("button.next")))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.airbnbActiveStep == 2 && _vm.selectedOption === 'owner_account') ? _c('div', [_c('div', {
    staticClass: "panel-step2"
  }, [_c('h4', {
    staticClass: "modal-title-icon"
  }, [_c('i', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/SuperHote_icons/wrench.svg",
      "alt": ""
    }
  })]), _vm._v("\n                          " + _vm._s(_vm.$t('account.settings.user_platforms_section.verify_and_connect')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "step2-content"
  }, [_c('p', {
    staticClass: "alert-text"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('account.settings.user_platforms_section.step2_content1')) + "\n                          ")]), _vm._v(" "), _c('p', {
    staticClass: "alert-text"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('account.settings.user_platforms_section.step2_content2')) + "\n                          ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-setup-aibnb mt-10",
    attrs: {
      "type": "button",
      "disabled": _vm.disableConnectAirbnbBtn
    },
    on: {
      "click": function($event) {
        _vm.airbnbConnectAibnb()
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": "static/assets/images/SuperHote_icons/airbnbIcon.svg",
      "alt": "",
      "width": "28",
      "height": "28"
    }
  })]), _vm._v("\n                          " + _vm._s(_vm.$t("account.settings.user_platforms_section.connect_with_airbnb")) + "\n                        ")]), _vm._v(" "), (_vm.airbnbActiveStep > 1) ? _c('button', {
    staticClass: "btn btn-inverse waves-effect waves-classic btn-save pull-left",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.prevStep()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.prev")) + "\n                        ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.airbnbActiveStep == 2 && _vm.selectedOption != 'owner_account') ? _c('div', [_c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title-icon"
  }, [_c('i', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/SuperHote_icons/send_mail.svg",
      "alt": ""
    }
  })]), _vm._v("\n                            " + _vm._s(_vm.$t('account.settings.user_platforms_section.send_mail')) + "\n                          ")])]), _vm._v(" "), _c('div', {
    staticClass: "step1-content"
  }, [_c('p', {
    staticClass: "alert-text"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('account.settings.user_platforms_section.step3_content5')) + "\n                          ")]), _vm._v(" "), _c('p', {
    staticClass: "alert-text",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('account.settings.user_platforms_section.step3_content6')) + "\n                          ")]), _vm._v(" "), _c('p', {
    staticClass: "alert-text"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('account.settings.user_platforms_section.step3_content7')) + "\n                          ")])]), _vm._v(" "), _c('div', {
    staticClass: "connect_other_account"
  }, [_c('div', {
    staticClass: "connect_other_account_step col-sm-4"
  }, [_c('span', [_vm._v(" 1")]), _vm._v(" "), _c('p', {
    staticClass: "alert-text",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('account.settings.user_platforms_section.step3_content8')) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "connect_other_account_step col-sm-4"
  }, [_c('span', [_vm._v(" 2")]), _vm._v(" "), _c('p', {
    staticClass: "alert-text"
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('account.settings.user_platforms_section.step3_content9')) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "connect_other_account_step col-sm-4"
  }, [_c('span', [_vm._v(" 3")]), _vm._v(" "), _c('p', {
    staticClass: "alert-text"
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('account.settings.user_platforms_section.step3_content10')) + "\n                            ")])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-right",
    attrs: {
      "type": "submit",
      "disabled": _vm.airbnbActiveLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendMail()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.send_email")))]), _vm._v(" "), (_vm.airbnbActiveStep > 1) ? _c('button', {
    staticClass: "btn btn-inverse waves-effect waves-classic btn-save pull-left",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.prevStep()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.prev")))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.airbnbActiveStep == 3) ? _c('div', [_c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title-icon"
  }, [_c('i', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/SuperHote_icons/wrench.svg",
      "alt": ""
    }
  })]), _vm._v("\n                            " + _vm._s(_vm.$t('account.settings.user_platforms_section.import_airbnb_rentals')) + "\n                          ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row"
  }, [_c('p', {
    staticClass: "alert-text"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('account.settings.user_platforms_section.step3_content1')) + "\n                          ")])]), _vm._v(" "), _c('div', {
    staticClass: "alert-message",
    staticStyle: {
      "max-width": "97%"
    }
  }, [_c('div', {
    staticClass: "alert-title"
  }, [_c('i', [_c('img', {
    attrs: {
      "src": "static/assets/images/SuperHote_icons/alert.svg",
      "alt": "",
      "width": "28",
      "height": "28"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "attention"
  }, [_vm._v(_vm._s(_vm.$t('account.settings.user_platforms_section.attention')))])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row"
  }, [_c('p', {
    staticClass: "alert-text"
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('account.settings.user_platforms_section.step3_content2')) + "\n                            ")]), _vm._v(" "), _c('p', {
    staticClass: "alert-text"
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('account.settings.user_platforms_section.step3_content3')) + "\n                            ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveLoading),
      expression: "airbnbActiveLoading"
    }],
    staticStyle: {
      "display": "flex",
      "flex-direction": "row",
      "justify-content": "center"
    }
  }, [_c('p', {
    staticClass: "synchro_in_progress"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('account.settings.user_platforms_section.step3_in_progress')) + "\n                          ")]), _vm._v(" "), _c('v-loading', {
    attrs: {
      "isLoading": _vm.airbnbActiveLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 45 45',
      "cx": 25,
      "cy": 25,
      "r": 10,
      "isHeightAuto": true
    }
  })], 1), _vm._v(" "), (_vm.listings.length === 0) ? _c('span', {
    staticStyle: {
      "color": "red",
      "text-align": "center",
      "width": "100%",
      "display": "block",
      "margin-top": "25px",
      "font-size": "14px"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.error ? _vm.error : 'Aucun hébergement trouvé sur ce compte Airbnb') + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.listings.length > 0) ? _c('table', {
    staticClass: "table table-responsive",
    attrs: {
      "id": "airbnb-accounts-table"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-step"
  }, [_vm._v("Annonces Airbnb du compte")]), _vm._v(" "), _c('th', {
    staticClass: "text-step"
  }, [_vm._v("Hébergements SuperHote correspondants")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listings), function(account) {
    return _c('tr', [_c('td', {
      staticClass: "text-align-center setting-change"
    }, [_c('i', [_c('img', {
      attrs: {
        "src": "static/assets/images/SuperHote_icons/airbnbIcon.svg",
        "alt": "",
        "width": "20",
        "height": "20"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "flex-direction": "column",
        "gap": "10px"
      }
    }, [_c('p', [_vm._v(_vm._s(account.name))]), _vm._v(" "), (account.rental_exists) ? _c('p', {
      staticStyle: {
        "color": "red",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm.$t('account.settings.user_platforms_section.step1_warning')) + "\n                                  ")]) : _vm._e()])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "channel-change setting-change "
    }, [_c('i', [_c('img', {
      attrs: {
        "src": "static/assets/images/SuperHote_icons/arrow.svg",
        "alt": "",
        "width": "20",
        "height": "20"
      }
    })]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (account.choice),
        expression: "account.choice"
      }],
      staticClass: "custom-select",
      attrs: {
        "id": "airbnb_username",
        "disabled": _vm.airbnbActiveLoading || account.rental_exists
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(account, "choice", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.options), function(option, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": String(option.value)
        }
      }, [_vm._v("\n                                      " + _vm._s(option.label) + "\n                                    ")])
    }))])])])
  }))]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-right",
    attrs: {
      "type": "submit",
      "disabled": _vm.airbnbActiveLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.airbnbConnectAibnb()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.end")) + "\n                      ")])]) : _vm._e()]), _vm._v(" "), (_vm.selectedOption === 'owner_account') ? _c('div', {
    staticClass: "col-sm-4 wizart-content"
  }, [_c('div', {
    staticClass: "close-popup-layout"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dismissModal()
      }
    }
  }, [_c('i', {
    staticClass: "icon md-close"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "wizart-list",
    staticStyle: {
      "padding-right": "16px"
    }
  }, [_c('li', {
    staticClass: "wizart-point",
    class: _vm.airbnbActiveStep == 1 ? 'active' : ''
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveStep == 1),
      expression: "airbnbActiveStep == 1"
    }]
  }, [_vm._v(" 1 ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveStep > 1),
      expression: "airbnbActiveStep > 1"
    }]
  }, [_c('i', {
    staticClass: "icon md-check"
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('account.settings.user_platforms_section.fill_new_account_credentials')))])]), _vm._v(" "), _c('li', {
    staticClass: "wizart-point",
    class: _vm.airbnbActiveStep == 2 ? 'active' : ''
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveStep <= 2),
      expression: "airbnbActiveStep <= 2"
    }]
  }, [_vm._v(" 2 ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveStep > 2),
      expression: "airbnbActiveStep > 2"
    }]
  }, [_c('i', {
    staticClass: "icon md-check"
  })]), _vm._v(" "), _c('p', [_vm._v("\n                          " + _vm._s(_vm.$t('account.settings.user_platforms_section.verify_and_connect')) + "\n                        ")])]), _vm._v(" "), _c('li', {
    staticClass: "wizart-point",
    class: _vm.airbnbActiveStep == 3 ? 'active' : ''
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveStep <= 4),
      expression: "airbnbActiveStep <= 4"
    }],
    staticStyle: {
      "max-width": "25px"
    }
  }, [_vm._v(" 3 ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveStep > 4),
      expression: "airbnbActiveStep > 4"
    }]
  }, [_c('i', {
    staticClass: "icon md-check"
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "flex": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.settings.user_platforms_section.import_rentals')))])])])]) : _vm._e(), _vm._v(" "), (_vm.selectedOption === 'another_account') ? _c('div', {
    staticClass: "col-sm-4 wizart-content"
  }, [_c('div', {
    staticClass: "wizart-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "close-popup-layout"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dismissModal()
      }
    }
  }, [_c('i', {
    staticClass: "icon md-close"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "wizart-list"
  }, [_c('li', {
    staticClass: "wizart-point",
    class: _vm.airbnbActiveStep == 1 ? 'active' : ''
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveStep == 1),
      expression: "airbnbActiveStep == 1"
    }]
  }, [_vm._v(" 1 ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveStep > 1),
      expression: "airbnbActiveStep > 1"
    }]
  }, [_c('i', {
    staticClass: "icon md-check"
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('account.settings.user_platforms_section.fill_new_account_credentials')))])]), _vm._v(" "), _c('li', {
    staticClass: "wizart-point",
    class: _vm.airbnbActiveStep == 2 ? 'active' : ''
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveStep <= 2),
      expression: "airbnbActiveStep <= 2"
    }]
  }, [_vm._v(" 2 ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.airbnbActiveStep > 2),
      expression: "airbnbActiveStep > 2"
    }]
  }, [_c('i', {
    staticClass: "icon md-check"
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('account.settings.user_platforms_section.send_mail')))])])])]) : _vm._e()])])])])]), _vm._v(" "), _c('v-stripe-connect', {
    attrs: {
      "stripeAccount": _vm.update_stripe
    },
    on: {
      "getStripeAccounts": _vm.getStripeAccounts
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "deleteStripeAccount",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.deleteStripeAccount(_vm.index_stripe)
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('account.settings.user_data_section.delete_stripe_account')) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#deleteStripeAccount')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#deleteStripeAccount')
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("button.cancel")) + "\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("button.delete")) + "\n                  ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "change-password-modal",
      "aria-hidden": "false",
      "aria-labelledby": "exampleGrid",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.changePassword()
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('account.users.change_password')) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#change-password-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('account.settings.old_password')))]), _vm._v(" "), _c('v-input-password', {
    attrs: {
      "classes": "form-control input-item",
      "error-classes": "text-xs leading-tight text-red-500",
      "required": ""
    },
    model: {
      value: (_vm.currentPassword),
      callback: function($$v) {
        _vm.currentPassword = $$v
      },
      expression: "currentPassword"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('account.settings.new_password')))]), _vm._v(" "), _c('v-input-password', {
    attrs: {
      "classes": "form-control input-item",
      "error-classes": "text-xs leading-tight text-red-500",
      "failed-validation-message": "Votre mot de passe doit comporter au moins 8 caractères et contenir au moins un chiffre, une lettre minuscule, une lettre majuscule et un caractère spécial.",
      "validation-regex": "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$",
      "required": ""
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('account.settings.retype_new_password')))]), _vm._v(" "), _c('v-input-password', {
    attrs: {
      "classes": "form-control input-item",
      "error-classes": "text-xs leading-tight text-red-500",
      "required": ""
    },
    model: {
      value: (_vm.repeatNewPassword),
      callback: function($$v) {
        _vm.repeatNewPassword = $$v
      },
      expression: "repeatNewPassword"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("button.save")) + "\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel my-10",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#change-password-modal')
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("button.cancel")) + "\n                  ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "get-properties-modal",
      "aria-hidden": "false",
      "aria-labelledby": "exampleGrid",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.importData()
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('account.users.import_rental')) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#get-properties-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.allProperties.length > 0) ? _c('div', [_c('p', {
    staticClass: "import-rentals-header"
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('account.index.import_rentals_header')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-t-15 form-material"
  }, [_c('div', {
    staticClass: "checkbox-custom m-1-10 checkbox-primary select-all"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isAllRentalsChecked),
      expression: "isAllRentalsChecked"
    }],
    attrs: {
      "type": "checkbox",
      "id": "all"
    },
    domProps: {
      "checked": Array.isArray(_vm.isAllRentalsChecked) ? _vm._i(_vm.isAllRentalsChecked, null) > -1 : (_vm.isAllRentalsChecked)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.isAllRentalsChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isAllRentalsChecked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isAllRentalsChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isAllRentalsChecked = $$c
        }
      }, function($event) {
        _vm.filterByRentals('all')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "all"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.index.all")))])]), _vm._v(" "), _vm._l((_vm.allProperties), function(property) {
    return _c('ul', {
      staticClass: "checkbox-custom sub-items m-1-30 checkbox-primary",
      staticStyle: {
        "margin-left": "10px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (property.checked),
        expression: "property.checked"
      }],
      attrs: {
        "type": "checkbox",
        "id": property.name
      },
      domProps: {
        "checked": Array.isArray(property.checked) ? _vm._i(property.checked, null) > -1 : (property.checked)
      },
      on: {
        "change": [function($event) {
          var $$a = property.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(property, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(property, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(property, "checked", $$c)
          }
        }, function($event) {
          _vm.filterByRentals(property.propId)
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": property.name
      }
    }, [_vm._v(_vm._s(property.name))]), _vm._v(" "), _vm._l((property.roomTypes), function(room) {
      return _c('li', {
        staticClass: "checkbox-custom m-1-10 checkbox-inline checkbox-primary dropdown-item"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (room.checked),
          expression: "room.checked"
        }],
        attrs: {
          "type": "checkbox",
          "id": room.name
        },
        domProps: {
          "checked": Array.isArray(room.checked) ? _vm._i(room.checked, null) > -1 : (room.checked)
        },
        on: {
          "change": [function($event) {
            var $$a = room.checked,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(room, "checked", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(room, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(room, "checked", $$c)
            }
          }, function($event) {
            _vm.filterByRooms(property.propId, room.roomId)
          }]
        }
      }), _vm._v(" "), _c('label', {
        attrs: {
          "for": room.name
        }
      }, [_vm._v(_vm._s(room.name))])])
    })], 2)
  })], 2)]) : _c('div', {
    staticClass: "m-t-15"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("account.settings.no_property")) + "\n                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#get-properties-modal')
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("button.cancel")) + "\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit",
      "disabled": _vm.allProperties.length == 0
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("button.import")) + "\n                  ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "edit-airbnb-account",
      "aria-hidden": "false",
      "aria-labelledby": "exampleGrid",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("account.users.edit_airbnb_pwd_title")) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#edit-airbnb-account')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(!_vm.changePwdStep) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    attrs: {
      "for": "airbnb-old-password"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('account.settings.old_password')) + "\n                        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editAirbnbAccountPwd.oldPassword),
      expression: "editAirbnbAccountPwd.oldPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "airbnb-old-password"
    },
    domProps: {
      "value": (_vm.editAirbnbAccountPwd.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editAirbnbAccountPwd, "oldPassword", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    attrs: {
      "for": "airbnb-new-password"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('account.settings.new_password')) + "\n                        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editAirbnbAccountPwd.password),
      expression: "editAirbnbAccountPwd.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "airbnb-new-password"
    },
    domProps: {
      "value": (_vm.editAirbnbAccountPwd.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editAirbnbAccountPwd, "password", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    attrs: {
      "for": "retype-new-airbnb-password"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('account.settings.retype_new_password')) + "\n                        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editAirbnbAccountPwd.password_confirmation),
      expression: "editAirbnbAccountPwd.password_confirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "retype-new-airbnb-password"
    },
    domProps: {
      "value": (_vm.editAirbnbAccountPwd.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editAirbnbAccountPwd, "password_confirmation", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.changePwdStep === 1) ? _c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title-icon"
  }, [_c('i', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/SuperHote_icons/cogs.svg",
      "alt": ""
    }
  })]), _vm._v("\n                      " + _vm._s(_vm.$t('account.settings.user_platforms_section.confirm_captcha')) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('p', [_vm._v("\n                      " + _vm._s(_vm.$t('account.settings.user_platforms_section.redirect_captcha_message')) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-auto mr-auto mt-60 waves-effect waves-classic btn-save pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.verifyAccount(_vm.airlockId, true)
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('account.settings.user_platforms_section.confirm_account_button')) + "\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.changePwdStep === 2) ? _c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title-icon"
  }, [_c('i', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/SuperHote_icons/cogs.svg",
      "alt": ""
    }
  })]), _vm._v("\n                      " + _vm._s(_vm.$t('account.settings.user_platforms_section.verify_and_connect')) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel default"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-title verification-title"
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('account.settings.user_platforms_section.verification_method_choice')) + "\n                        ")]), _vm._v(" "), _vm._l((_vm.verificationFrictionData), function(data) {
    return _c('div', {
      staticClass: "m-10 radio-custom radio-primary"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.verificationFrictionType),
        expression: "verificationFrictionType"
      }],
      class: data.name,
      attrs: {
        "type": "radio",
        "id": data.id,
        "name": "account_confirmation"
      },
      domProps: {
        "value": data.name,
        "checked": _vm._q(_vm.verificationFrictionType, data.name)
      },
      on: {
        "change": function($event) {
          _vm.verificationFrictionType = data.name
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "control-label",
      attrs: {
        "for": data.id
      }
    }, [_vm._v(_vm._s(data.text))])])
  })], 2)])]), _vm._v(" "), _c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-right mb-4",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.verifyAirbnbAccountViaPhoneOrEmail(true)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("button.next")) + "\n                  ")])], 1) : _vm._e(), _vm._v(" "), (_vm.changePwdStep === 3) ? _c('div', [_c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel default"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-title verification-title"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('account.settings.user_platforms_section.confirm_airbnb_sent_code')) + "\n                          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material col-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "airbnb_code"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.airbnb_code")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.airbnbVerificationCode),
      expression: "airbnbVerificationCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.airbnbVerificationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.airbnbVerificationCode = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-right mb-4",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.checkAirBnbVerificationCode(true)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("button.next")) + "\n                  ")])], 1) : _vm._e()]), _vm._v(" "), (!_vm.changePwdStep) ? _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": _vm.smallLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#edit-airbnb-account')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('button.cancel')) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "button",
      "disabled": _vm.smallLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editAirbnbAccount(_vm.editAirbnbAccountPwd)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("button.edit")) + "\n                ")])], 1) : _vm._e()])])]), _vm._v(" "), _c('v-configure-igloohome', {
    attrs: {
      "apiKey": _vm.igloohomeApiKey
    },
    on: {
      "fetchAccount": _vm.fetch_account
    }
  }), _vm._v(" "), _c('v-configure-igloohome-v2', {
    attrs: {
      "user": _vm.users
    }
  }), _vm._v(" "), _c('v-configure-nuki-lock', {
    attrs: {
      "apiKey": _vm.nukiApiKey
    },
    on: {
      "fetchAccount": _vm.fetch_account
    }
  }), _vm._v(" "), _c('v-import-new-airbnb-rentals', {
    ref: "airbnbImportModal"
  }), _vm._v(" "), _c('v-vrbo-user-connection-modal', {
    attrs: {
      "user": _vm.users,
      "fetchAccount": _vm.fetch_account
    }
  }), _vm._v(" "), _c('v-google-user-connection-modal', {
    attrs: {
      "user": _vm.users,
      "fetchAccount": _vm.fetch_account
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a665f96"}!./src/app/pages/account/settings/settings.html
// module id = 1372
// module chunks = 0